import React from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgThumbnail from "lightgallery/plugins/thumbnail";

const GiftBasketGallery = () => {
  /*eslint-disable */
  return (
    <section id="gift-basket-gallery" className="gallery">
      <h1 className="title">Giỏ Quà Tết</h1>
      <LightGallery
        download={false}
        plugins={[lgZoom, lgVideo, lgShare, lgThumbnail]}
        mode="lg-fade"
      >
        {/* 1 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC01 sp.png"
          data-sub-html="<h1>Giỏ quà GQ01</h1><h2>1.049.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC01.png"
            width="300"
            height="300"
          />
        </a>

        {/* 2 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC02 sp.png"
          data-sub-html="<h1>Giỏ quà GQ02</h1><h2>979.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC02.png"
            width="300"
            height="300"
          />
        </a>

        {/* 3 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC03 sp.png"
          data-sub-html="<h1>Giỏ quà GQ03</h1><h2>1.549.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC03.png"
            width="300"
            height="300"
          />
        </a>

        {/* 4 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC04 sp.png"
          data-sub-html="<h1>Giỏ quà GQ4</h1><h2>1.149.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC04.png"
            width="300"
            height="300"
          />
        </a>

        {/* 5 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC05 sp.png"
          data-sub-html="<h1>Giỏ quà GQ05</h1><h2>1.239.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC05.png"
            width="300"
            height="300"
          />
        </a>

        {/* 6 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC06 sp.png"
          data-sub-html="<h1>Giỏ quà GQ06</h1><h2>629.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC06.png"
            width="300"
            height="300"
          />
        </a>

        {/* 7 */}
        <a
          className="gallery-item"
          data-src="images/products/gift-basket/GC07 sp.png"
          data-sub-html="<h1>Giỏ quà GQ07</h1><h2>1.189.000 đồng</h2>"
        >
          <img
            className="img-responsive"
            src="images/products/gift-basket/GC07.png"
            width="300"
            height="300"
          />
        </a>
      </LightGallery>
    </section>
  );
};

export default GiftBasketGallery;
